'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLeaderboard = exports.deleteLeaderboardDefinitions = exports.deleteLeaderboardDefinition = exports.createLeaderboardDefinitions = exports.createLeaderboardDefinition = exports.fetchLeaderboardDefinitions = exports.fetchLeaderboardDefinition = exports.generateLeaderboardId = exports.getShortMeasurementDomain = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _kebabCase = require('lodash/kebabCase');

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _client = require('../client');

var client = _interopRequireWildcard(_client);

var _params = require('../params');

var _tags = require('../tags');

var _sparkMd = require('spark-md5');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getShortMeasurementDomain = exports.getShortMeasurementDomain = function getShortMeasurementDomain() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'any:distance';

  switch (domain) {
    case 'fundraising:donations_made':
      return 'fc';
    case 'any:elapsed_time':
    case 'hike:elapsed_time':
    case 'ride:elapsed_time':
    case 'swim:elapsed_time':
    case 'walk:elapsed_time':
      return [domain.charAt(0), 't'].join('');
    default:
      return domain.split(':').map(function (substring) {
        return substring.charAt(0);
      }).join('');
  }
};

var genId = function genId(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === undefined ? (0, _params.required)() : _ref$id,
      _ref$measurementDomai = _ref.measurementDomain,
      measurementDomain = _ref$measurementDomai === undefined ? 'any:distance' : _ref$measurementDomai,
      name = _ref.name,
      tagId = _ref.tagId,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'campaign' : _ref$type;

  return (0, _sparkMd.hash)([type, getShortMeasurementDomain(measurementDomain), id, tagId, name].filter(Boolean).map(_kebabCase2.default).join('-'));
};

var generateLeaderboardId = exports.generateLeaderboardId = genId;

var fetchLeaderboardDefinition = exports.fetchLeaderboardDefinition = function fetchLeaderboardDefinition(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$measurementDoma = _ref2.measurementDomain,
      measurementDomain = _ref2$measurementDoma === undefined ? 'any:distance' : _ref2$measurementDoma,
      name = _ref2.name,
      tagId = _ref2.tagId,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'campaign' : _ref2$type;

  var definitionId = genId({ id: id, measurementDomain: measurementDomain, name: name, tagId: tagId, type: type });

  return client.get('/v1/tags/leaderboard/definition/' + definitionId).then(function (data) {
    return data.definition;
  });
};

var fetchLeaderboardDefinitions = exports.fetchLeaderboardDefinitions = function fetchLeaderboardDefinitions(params) {
  return Promise.all(_tags.measurementDomains.map(function (measurementDomain) {
    return fetchLeaderboardDefinition(_extends({}, params, { measurementDomain: measurementDomain }));
  }));
};

var createLeaderboardDefinition = exports.createLeaderboardDefinition = function createLeaderboardDefinition(_ref3) {
  var _ref3$id = _ref3.id,
      id = _ref3$id === undefined ? (0, _params.required)() : _ref3$id,
      _ref3$conditions = _ref3.conditions,
      conditions = _ref3$conditions === undefined ? [] : _ref3$conditions,
      _ref3$label = _ref3.label,
      label = _ref3$label === undefined ? 'Page Campaign Link' : _ref3$label,
      _ref3$measurementDoma = _ref3.measurementDomain,
      measurementDomain = _ref3$measurementDoma === undefined ? 'any:distance' : _ref3$measurementDoma,
      name = _ref3.name,
      tagId = _ref3.tagId,
      _ref3$type = _ref3.type,
      type = _ref3$type === undefined ? 'campaign' : _ref3$type;

  var segment = ['page', type, id].join(':');
  var primaryUnit = (0, _tags.getPrimaryUnit)(measurementDomain);
  var definitionId = genId({ id: id, measurementDomain: measurementDomain, name: name, tagId: tagId, type: type });

  var payload = {
    conditions: conditions,
    id: definitionId,
    measurementDomain: measurementDomain,
    primaryUnit: primaryUnit,
    segment: segment,
    tagDefinition: {
      id: tagId || segment,
      label: label
    }
  };

  return client.post('/v1/tags/leaderboard/definition/' + definitionId, payload).then(function (data) {
    return _extends({}, data.definition, { updated: true });
  }).catch(function (_ref4) {
    var _ref4$data = _ref4.data,
        data = _ref4$data === undefined ? {} : _ref4$data;

    var errorMessage = data.errorMessage;

    if (errorMessage && errorMessage.indexOf('already has totals') > -1) {
      return Promise.resolve(_extends({}, payload, {
        updated: false
      }));
    }

    return Promise.reject(data);
  });
};

var createLeaderboardDefinitions = exports.createLeaderboardDefinitions = function createLeaderboardDefinitions(params) {
  return Promise.all(_tags.measurementDomains.map(function (measurementDomain) {
    return createLeaderboardDefinition(_extends({}, params, { measurementDomain: measurementDomain }));
  }));
};

var deleteLeaderboardDefinition = exports.deleteLeaderboardDefinition = function deleteLeaderboardDefinition(_ref5) {
  var _ref5$id = _ref5.id,
      id = _ref5$id === undefined ? (0, _params.required)() : _ref5$id,
      _ref5$measurementDoma = _ref5.measurementDomain,
      measurementDomain = _ref5$measurementDoma === undefined ? 'any:distance' : _ref5$measurementDoma,
      name = _ref5.name,
      tagId = _ref5.tagId,
      _ref5$type = _ref5.type,
      type = _ref5$type === undefined ? 'campaign' : _ref5$type;

  var definitionId = genId({ id: id, measurementDomain: measurementDomain, name: name, tagId: tagId, type: type });

  return client.destroy('/v1/tags/leaderboard/definition/' + definitionId);
};

var deleteLeaderboardDefinitions = exports.deleteLeaderboardDefinitions = function deleteLeaderboardDefinitions(params) {
  return Promise.all(_tags.measurementDomains.map(function (measurementDomain) {
    return deleteLeaderboardDefinition(_extends({}, params, { measurementDomain: measurementDomain }));
  }));
};

var fetchLeaderboard = exports.fetchLeaderboard = function fetchLeaderboard(_ref6) {
  var _ref6$id = _ref6.id,
      id = _ref6$id === undefined ? (0, _params.required)() : _ref6$id,
      _ref6$activityType = _ref6.activityType,
      activityType = _ref6$activityType === undefined ? 'fundraising' : _ref6$activityType,
      _ref6$limit = _ref6.limit,
      limit = _ref6$limit === undefined ? 10 : _ref6$limit,
      _ref6$sortBy = _ref6.sortBy,
      sortBy = _ref6$sortBy === undefined ? 'donations_received' : _ref6$sortBy,
      tagId = _ref6.tagId,
      tagValue = _ref6.tagValue,
      _ref6$type = _ref6.type,
      type = _ref6$type === undefined ? 'campaign' : _ref6$type;

  var leaderboardId = genId({
    id: id,
    measurementDomain: [activityType, sortBy].join(':'),
    name: tagValue,
    tagId: tagId,
    type: type
  });

  var query = '\n    {\n      leaderboard(\n        id: "' + leaderboardId + '"\n      ) {\n        totals(limit: ' + limit + ') {\n          tagValue\n          tagValueAsNode {\n            ... on Page {\n              slug\n              title\n              summary\n              status\n              legacyId\n              url\n              owner {\n                name\n              }\n              donationSummary {\n                donationCount\n                offlineAmount {\n                  value\n                  currencyCode\n                }\n                totalAmount {\n                  value\n                  currencyCode\n                }\n              }\n              targetWithCurrency {\n                value\n                currencyCode\n              }\n              heroMedia {\n                ... on ImageMedia {\n                  url\n                }\n              }\n            }\n          }\n          amounts {\n            value\n            unit\n          }\n        }\n      }\n    }\n  ';

  return client.servicesAPI.post('/v1/justgiving/graphql', { query: query }).then(function (response) {
    return response.data;
  }).then(function (result) {
    return (0, _get2.default)(result, 'data.leaderboard.totals', []);
  }).then(function (results) {
    return results.map(function (item) {
      return _extends({}, item, item.tagValueAsNode);
    });
  });
};